<div class="toast toast-top toast-center">
  @for (
    notification of activeNotifications().activeNotifications;
    track notification.id
  ) {
    <div
      class="alert"
      [class.alert-success]="notification.notificationType == 'success'"
      [class.alert-warning]="notification.notificationType == 'warning'"
      [class.alert-error]="notification.notificationType == 'error'"
    >
      <span>
        {{ notification.notification }}
      </span>
    </div>
  }
</div>
